import React from "react";

export const DropDownChevron = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 16 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 1.828L11.2905 0.179688L6.77778 4.53128L2.26502 0.179688L0.555556 1.828L6.77778 7.828L13 1.828Z"
        fill="currentColor"
      />
    </svg>
  );
};
